module.exports = __webpack_public_path__ + "img/HT.3d3350d8.svg";